<app-navbar-style-two></app-navbar-style-two>

<section class="menu-section">
  <div class="container">

    <!-- Page Header -->
    <div class="menu-header">
      <h1 class="menu-heading">Our Menu</h1>
      <p class="menu-subheading">Fresh · Hot · Made for you</p>
      <div class="location-hours-bar">
        <span class="location-info">
          <i class='bx bx-map'></i>
          {{ location }}
        </span>
        <span class="separator">•</span>
        <span class="hours-info">
          <i class='bx bx-time'></i>
          {{ hours }}
        </span>
        <a href="{{ directionsUrl }}" target="_blank" class="directions-link">
          <i class='bx bx-navigation'></i>
          Get Directions
        </a>
      </div>
      <div class="menu-search-bar">
        <div class="search-input-wrapper">
          <i class='bx bx-search'></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search dishes..."
            (input)="onSearchItems($event)"
            [value]="searchQuery">
          <button *ngIf="searchQuery" class="clear-search" (click)="clearSearch()">
            <i class='bx bx-x'></i>
          </button>
        </div>
      </div>
      <button class="download-menu-btn" (click)="downloadMenu()" aria-label="Download Menu">
        <i class='bx bx-download'></i>
        <span>Download Menu</span>
      </button>
    </div>

    <!-- Veg Only toggle -->
    <div class="veg-toggle-row">
      <div class="veg-toggle-card" [class.active]="vegOnly" (click)="toggleVegOnly()" role="button" tabindex="0" aria-label="Toggle Veg Only"
        (keydown.enter)="toggleVegOnly()" (keydown.space)="toggleVegOnly(); $event.preventDefault()">
        <div class="veg-indicator-box">
          <span class="veg-dot"></span>
        </div>
        <span class="veg-toggle-label">Veg Only</span>
        <div class="toggle-switch">
          <span class="toggle-thumb"></span>
        </div>
      </div>
    </div>

    <!-- Category Filter Bar -->
    <div class="filter-bar-sticky" *ngIf="showFilterBar" [class.is-stuck]="isCategorySticky">
      <div class="filter-bar-top">
        <div class="veg-toggle-card" [class.active]="vegOnly" (click)="toggleVegOnly()" role="button" tabindex="0" aria-label="Toggle Veg Only">
          <div class="veg-indicator-box">
            <span class="veg-dot"></span>
          </div>
          <span class="veg-toggle-label">Veg Only</span>
          <div class="toggle-switch">
            <span class="toggle-thumb"></span>
          </div>
        </div>
      </div>

      <div class="category-scroll-wrapper">
        <div class="category-bar" #categoryBar>
          <button *ngFor="let cat of projectCategories" class="cat-btn"
            [class.active]="selectedCategory === cat.id"
            (click)="filterProjects(cat.id)">
            <img *ngIf="cat.image" [src]="cat.image" [alt]="cat.name" class="cat-image">
            <div *ngIf="!cat.image" class="cat-icon-placeholder">
              <i [class]="cat.icon"></i>
            </div>
            <span class="cat-name">{{ cat.name }}</span>
            <span class="cat-count">{{ getCategoryItemCount(cat.id) }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Active filter summary -->
    <div class="filter-summary" *ngIf="isFiltering && menuGroups.length > 0">
      <span class="filter-summary-text">
        <i class='bx bx-filter-alt'></i>
        <strong>{{ visibleDishCount }}</strong> {{ visibleDishCount === 1 ? 'dish' : 'dishes' }}
        in <strong>{{ menuGroups.length }}</strong> {{ menuGroups.length === 1 ? 'category' : 'categories' }}
        <ng-container *ngIf="searchQuery"> for "<em>{{ searchQuery }}</em>"</ng-container>
        <ng-container *ngIf="vegOnly"> · Veg only</ng-container>
      </span>
      <button type="button" class="filter-summary-clear" (click)="clearAllFilters()">Clear</button>
    </div>

    <!-- Menu Accordion (category dropdowns, 2 columns on desktop) -->
    <div class="menu-accordion" #productsSection>
      <ng-container *ngIf="menuGroups.length > 0; else emptyState">
        <div class="acc-column" *ngFor="let col of accColumns; trackBy: trackByIndex">

          <div class="acc-item" *ngFor="let group of col; trackBy: trackByGroup" [style.order]="group.order"
            [class.open]="isGroupOpen(group.id)">

            <button type="button" class="acc-header" [class.has-img]="group.image"
              (click)="toggleGroup(group.id)" [attr.aria-expanded]="isGroupOpen(group.id)">
              <img *ngIf="group.image" class="acc-cat-img" [src]="group.image" [alt]="group.name"
                (error)="$event.target.style.display='none'">
              <!-- <img *ngIf="group.image" class="acc-cat-img" src="../../../../assets/img/slider/banner2.jpg" [alt]="group.name"
                (error)="$event.target.style.display='none'"> -->
              <span class="acc-title-wrap">
                <span class="acc-title">{{ group.name }}</span>
                <span class="acc-count" [attr.aria-label]="group.items.length + ' dishes'">{{ group.items.length }}</span>
              </span>
              <i class='bx bx-chevron-down acc-chevron'></i>
            </button>

            <div class="acc-panel" [class.open]="isGroupOpen(group.id)">
              <div class="acc-panel-inner">

                <div class="acc-row" *ngFor="let item of group.items; trackBy: trackByItem">

                  <div class="acc-row-main">
                    <div class="pd-title-row">
                      <!-- Food-Type Indicator -->
                      <span *ngIf="isVeg(item.dish_type)" class="food-indicator veg" title="Veg (Vegetarian)">
                        <span class="indicator-box"><span class="indicator-dot"></span></span>
                      </span>
                      <span *ngIf="isNonVeg(item.dish_type)" class="food-indicator non-veg" title="Non-Veg">
                        <span class="indicator-box"><span class="indicator-dot"></span></span>
                      </span>
                      <span *ngIf="isEgg(item.dish_type)" class="food-indicator egg" title="Egg">
                        <span class="indicator-box"><span class="indicator-dot"></span></span>
                      </span>

                      <h3 class="pd-name">{{ item.title }}</h3>

                      <!-- Kids Friendly Icon -->
                      <span *ngIf="isKidFriendly(item)" class="kids-badge" title="Kids Friendly">
                       <i class='bx bxs-face'></i>
                        <span class="kids-text">Kids</span>
                      </span>

                      <!-- Spicy Icon -->
                      <span *ngIf="isSpicy(item)" class="spicy-badge" title="Spicy">
                       <!-- <i class='bx bxs-hot'></i> -->
                        🌶️
                      </span>
                    </div>

                    <p class="pd-weight" *ngIf="item.description">{{ item.description }}</p>

                    <!-- Customizable hint (combos / rice & noodles) -->
                    <p class="pd-custom-hint" *ngIf="item.customConfig">
                      <i class='bx bx-slider-alt'></i>
                      {{ item.customConfig.hint }}
                    </p>
                  </div>

                  <!-- Desktop: image slides in on the left on hover · Mobile / tablet: thumbnail on the right -->
                  <img class="acc-thumb" [src]="item.image" [alt]="item.title"
                     loading="lazy">

                  <div class="acc-row-side">
                    <div class="pd-price-wrap">
                      <span class="pd-price-from" *ngIf="item.customConfig?.priceFrom">From</span>
                      <span class="pd-price">${{ item.price }}</span>
                      <span >{{ item.size }}</span>
                    </div>

                    <div class="pd-right">
                      <!-- Customizable item: opens selector -->
                      <ng-container *ngIf="item.customConfig">
                        <span class="pd-incart-note" *ngIf="item.cartCount > 0">{{ item.cartCount }} in cart</span>
                        <button class="pd-customize-btn" [class.added]="item.justAdded"
                          (click)="openCustomizer(item)" aria-label="Customize and add to cart">
                          <i class='bx' [ngClass]="item.justAdded ? 'bx-check' : 'bx-slider-alt'"></i>
                          <span>{{ item.justAdded ? 'Added' : 'Customize' }}</span>
                        </button>
                      </ng-container>

                      <div class="pd-qty-control" *ngIf="!item.customConfig && item.inCart">
                        <button class="pd-qty-btn pd-qty-minus" (click)="decreaseQuantity(item)"
                          aria-label="Decrease quantity">
                          <i class='bx bx-minus'></i>
                        </button>
                        <span class="pd-qty-value">{{ item.quantity }}</span>
                        <button class="pd-qty-btn pd-qty-plus" (click)="increaseQuantity(item)"
                          aria-label="Increase quantity">
                          <i class='bx bx-plus'></i>
                        </button>
                      </div>
                      <button class="pd-add-btn" [class.added]="item.justAdded" [class.in-cart]="item.inCart"
                        (click)="addToCart(item)" *ngIf="!item.customConfig && !item.inCart" aria-label="Add to cart">
                        <i class='bx' [ngClass]="item.justAdded ? 'bx-check' : 'bx-plus'"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="acc-empty" *ngIf="!group.items.length" [class.is-special]="isSpecialGroup(group)">
                  <div class="acc-empty-icon">
                    <span *ngIf="isSpecialGroup(group)" class="acc-empty-emoji">🚚</span>
                    <i *ngIf="!isSpecialGroup(group)" class='bx bx-dish'></i>
                  </div>

                  <ng-container *ngIf="isSpecialGroup(group); else defaultEmpty">
                    <h4 class="acc-empty-title">Today's special</h4>
                    <p class="acc-empty-text">Ask at the truck</p>
                  </ng-container>

                  <ng-template #defaultEmpty>
                    <h4 class="acc-empty-title">Coming soon</h4>
                    <p class="acc-empty-text">No dishes in this category yet</p>
                  </ng-template>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #emptyState>
        <!-- Everyday Special with no dish added yet -->
        <div class="empty-state special-empty" *ngIf="isEverydaySpecialSelected && !searchQuery && !vegOnly">
          <div class="empty-icon">🚚</div>
          <h3>Today's special coming soon</h3>
          <p>Ask at the truck</p>
        </div>

        <div class="empty-state" *ngIf="!(isEverydaySpecialSelected && !searchQuery && !vegOnly)">
          <div class="empty-icon">🍽️</div>
          <h3>Nothing here yet</h3>
          <p *ngIf="vegOnly">No Veg dishes found. Try turning off "Veg Only" toggle.</p>
          <p *ngIf="!vegOnly && searchQuery">No dishes match "{{ searchQuery }}". Try a different search term.</p>
          <p *ngIf="!vegOnly && !searchQuery">Try a different category</p>
          <button type="button" class="empty-clear-btn" *ngIf="isFiltering" (click)="clearAllFilters()">
            <i class='bx bx-refresh'></i> Clear filters
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</section>

<!-- Customize Modal (Mid Day Fuel, Fried Rice / Noodles) -->
<div class="cz-backdrop" *ngIf="customItem" (click)="closeCustomizer()">
  <div class="cz-modal" role="dialog" aria-modal="true" [attr.aria-label]="'Customize ' + customItem.title"
    (click)="$event.stopPropagation()">

    <div class="cz-header">
      <div class="cz-header-text">
        <h3 class="cz-title">{{ customItem.title }}</h3>
        <p class="cz-sub" *ngIf="customItem.description">{{ customItem.description }}</p>
      </div>
      <button class="cz-close" (click)="closeCustomizer()" aria-label="Close">
        <i class='bx bx-x'></i>
      </button>
    </div>

    <div class="cz-body">
      <div class="cz-group" *ngFor="let group of customItem.customConfig.groups">
        <div class="cz-group-head">
          <span class="cz-group-title">{{ group.label }}</span>
          <span class="cz-tag" [class.required]="group.required">{{ group.required ? 'Required' : 'Optional' }}</span>
        </div>
        <div class="cz-options" [attr.role]="group.type === 'single' ? 'radiogroup' : 'group'">
          <button type="button" class="cz-chip" *ngFor="let choice of group.choices"
            [class.selected]="isChoiceSelected(group, choice)"
            [attr.role]="group.type === 'single' ? 'radio' : 'checkbox'"
            [attr.aria-checked]="isChoiceSelected(group, choice)"
            (click)="onChoiceClick(group, choice)">
            <span class="cz-mark" [class.square]="group.type === 'multi'"></span>
            <span class="cz-chip-label">{{ choice.label }}</span>
            <span class="cz-extra" *ngIf="choice.price">+${{ choice.price | number:'1.2-2' }}</span>
          </button>
        </div>
      </div>

      <div class="cz-group cz-included" *ngIf="customItem.customConfig.included?.length">
        <div class="cz-group-head">
          <span class="cz-group-title">Included with your combo</span>
        </div>
        <div class="cz-included-list">
          <span class="cz-included-pill" *ngFor="let inc of customItem.customConfig.included">
            <i class='bx bx-check'></i>{{ inc }}
          </span>
        </div>
      </div>
    </div>

    <div class="cz-qty-row">
      <span class="cz-group-title">Quantity</span>
      <div class="cz-qty-control">
        <button type="button" class="cz-qty-btn" (click)="decreaseCustomQty()" [disabled]="customQty <= 1" aria-label="Decrease quantity">
          <i class='bx bx-minus'></i>
        </button>
        <span class="cz-qty-value">{{ customQty }}</span>
        <button type="button" class="cz-qty-btn" (click)="increaseCustomQty()" aria-label="Increase quantity">
          <i class='bx bx-plus'></i>
        </button>
      </div>
    </div>

    <div class="cz-footer">
      <div class="cz-total">
        <span class="cz-total-label">Total<ng-container *ngIf="customQty > 1"> · {{ customQty }} × ${{ customUnitPrice | number:'1.2-2' }}</ng-container></span>
        <span class="cz-total-value">${{ customTotal | number:'1.2-2' }}</span>
      </div>
      <button class="cz-add-btn" [disabled]="!customReady" (click)="addCustomToCart()">
        <i class='bx bx-plus'></i>
        <span>Add to Cart</span>
      </button>
    </div>
    <p class="cz-missing" *ngIf="!customReady">Please choose: {{ customMissing.join(', ') }}</p>
  </div>
</div>
